import { newId } from "./BaseObject";

import Logger from "../Logger";

const logger = new Logger();

//
// for mapping after copy
//
export default class ObjectMapping {
  allMappedIds = new Map<string, string>();

  getMappedId(id: string | undefined): string | undefined {
    if (id) {
      //
      // check if id exists in global id map
      //   if not.... the id is likely mapped twice
      //
      const obj = state.objectRegistry.allObjects.get(id);
      if (obj == undefined) {
        let alreadyMapped = false;
        for (let [key, value] of this.allMappedIds) {
          if (value == id) {
            alreadyMapped = true;
            break;
          }
        }

        if (alreadyMapped) {
          logger.error(`getMappedId called with already mapped id: ${id}`);
          return id;
        } else {
          logger.error(`getMappedId called with illegal id: ${id}`);
          return undefined;
        }
      }

      //
      // execute mapping
      //
      var mappedId = this.allMappedIds.get(id);
      if (mappedId == undefined) {
        mappedId = newId();
        this.allMappedIds.set(id, mappedId);
      }

      console.log(`getMappdId`);
      return mappedId;
    } else {
      return undefined;
    }
  }
}
